<template>
    <div>
        <!-- <div class="d-flex justify-content-between align-items-center mb-2">
            <input
                v-model="search"
                type="text"
                class="form-control form-control-sm w-auto"
                placeholder="Cari action / route / ip"
                style="max-width:240px"
            />
        </div> -->
        
        <div class="table-responsive">
            <table class="table table-borderless table-hover mb-0">
            <thead>
                <tr>
                    <th>Time</th>
                    <th>IP</th>
                    <th>Action</th>
                    <th>Route</th>
                    <th>Method</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in paginatedData" :key="item.id">
                    <td class="align-middle text-nowrap"><b>{{ formatDate(item.created_at) }}</b></td>
                    <td class="align-middle">{{ item.ip }}</td>
                    <td class="align-middle"><span class="badge badge-info">{{ item.action }}</span></td>
                    <td class="align-middle text-monospace">{{ item.route }}</td>
                    <td class="align-middle">{{ item.method }}</td>
                    <td class="align-middle">
                        <span   
                        :class="[
                            'badge',
                            item.success ? 'badge-success' : 'badge-danger'
                        ]"
                        >{{ item.success ? 'SUCCESS' : 'FAILED' }}</span>
                    </td>
                    <td class="align-middle">
                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            @click="openDetail(item)">
                            Detail
                        </button>
                    </td>
                </tr>
            </tbody>
            </table>
            <div v-if="!paginatedData.length" class="text-center py-4 text-muted">No data</div>
        </div>

        <b-modal
            id="audit-log-detail-modal"
            v-model="isDetailModalOpen"
            title="Audit Log Detail"
            size="lg"
            ok-only
            ok-title="Tutup">
            <div v-if="selectedLog" class="detail-grid">
                <div class="detail-item">
                    <span class="detail-label">Time</span>
                    <span class="detail-value">{{ formatDate(selectedLog.created_at) }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-label">IP</span>
                    <span class="detail-value">{{ selectedLog.ip || '-' }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-label">Action</span>
                    <span class="detail-value">{{ selectedLog.action || '-' }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-label">Route</span>
                    <span class="detail-value text-monospace">{{ selectedLog.route || '-' }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-label">Method</span>
                    <span class="detail-value">{{ selectedLog.method || '-' }}</span>
                </div>
                <div class="detail-item">
                    <span class="detail-label">Status</span>
                    <span class="detail-value">
                        <span :class="['badge', selectedLog.success ? 'badge-success' : 'badge-danger']">
                            {{ selectedLog.success ? 'SUCCESS' : 'FAILED' }}
                        </span>
                    </span>
                </div>
                <div class="detail-item detail-item--full">
                    <span class="detail-label">Message</span>
                    <span class="detail-value">{{ selectedLog.message || '-' }}</span>
                </div>
                <div class="detail-item detail-item--full" v-if="selectedLog.user_agent">
                    <span class="detail-label">User Agent</span>
                    <span class="detail-value text-break">{{ selectedLog.user_agent }}</span>
                </div>
                <div class="detail-item detail-item--full" v-if="selectedLog.request !== null && selectedLog.request !== undefined">
                    <span class="detail-label">Request</span>
                    <pre class="detail-json">{{ formatJson(selectedLog.request) }}</pre>
                </div>
                <div class="detail-item detail-item--full" v-if="selectedLog.response !== null && selectedLog.response !== undefined">
                    <span class="detail-label">Response</span>
                    <pre class="detail-json">{{ formatJson(selectedLog.response) }}</pre>
                </div>
            </div>
        </b-modal>
  
        <!-- Pagination -->
        <div class="d-flex justify-content-between align-items-center mt-2">

            <laravel-pagination
                :pagination="paginationData"
                @change="changePage"
            />
        
        </div>
        
    </div>
</template>

<script>
    import LaravelPagination from './LaravelPagination.vue';
    export default {
        name: 'AuditLogTable',
        components: {
            LaravelPagination
        },
        props: {
            logs: {
                type: [Object, Array],
                default: () => ({ data: [] })
            }
        },
        data() {
            return {
                search: '',
                isDetailModalOpen: false,
                selectedLog: null,
                pagination: {},
            };
        },
        computed: {
            paginatedData() {
                if (Array.isArray(this.logs)) {
                    return this.logs;
                }

                if (this.logs && Array.isArray(this.logs.data)) {
                    return this.logs.data;
                }

                return [];
            },

            paginationData() {
                if (!this.logs || Array.isArray(this.logs)) {
                    return {};
                }

                return this.logs;
            }
        },
        methods: {
            async loadAuditLog(page = 1) {
                try {
                    const res = await this.$http.get(`/api/ags/odol/audit-log?page=${page}`);

                    this.$emit('update-audit-log', res.data.data);

                    // atau kalau auditLogData berada di component ini
                    // this.auditLogData = res.data.data;

                } catch (e) {
                    console.error(e);
                }
            },
            changePage(page) {
                this.$emit('page-change', page);
            },
            openDetail(item) {
                this.selectedLog = item;
                this.isDetailModalOpen = true;
            },
            formatJson(value) {
                if (typeof value === 'string') {
                    return value;
                }

                try {
                    return JSON.stringify(value, null, 2);
                } catch (error) {
                    return String(value);
                }
            },
            formatDate(value) {
                if (!value) {
                    return '-';
                }

                const date = new Date(value);
                if (Number.isNaN(date.getTime())) {
                    return value;
                }

                const dd = String(date.getDate()).padStart(2, '0');
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const yyyy = date.getFullYear();
                const hh = String(date.getHours()).padStart(2, '0');
                const mi = String(date.getMinutes()).padStart(2, '0');
                const ss = String(date.getSeconds()).padStart(2, '0');

                return `${dd}-${mm}-${yyyy} ${hh}:${mi}:${ss}`;
            }
        },
        watch: {
            search(value) {
                this.$emit('search-change', value);
            }
        },
        mounted() {
            console.log('AuditLogTable mounted');
            console.log('logs =', this.logs);
            console.log('isArray =', Array.isArray(this.logs));
        }
    };
</script>

<style scoped>
.detail-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
}

.detail-item {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 0.65rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    background: #f8fafc;
}

.detail-item--full {
    grid-column: 1 / -1;
}

.detail-label {
    font-size: 0.75rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-weight: 700;
}

.detail-value {
    color: #0f172a;
    font-weight: 500;
}

.detail-json {
    margin: 0;
    padding: 0.75rem;
    border-radius: 0.5rem;
    background: #0f172a;
    color: #f8fafc;
    font-size: 0.75rem;
    max-height: 220px;
    overflow: auto;
}

@media (max-width: 767.98px) {
    .detail-grid {
        grid-template-columns: 1fr;
    }
}
</style>